import React from 'react';
import { Link } from 'react-router-dom';
import ButtonBase from '@material-ui/core/ButtonBase';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import { SOURCES } from 'features/new-candidate/constants';
import { EntityRoutes } from 'routes/constants';
import strings from 'strings';
import { TALENT_POOL_URL } from 'UI/constants/defaults';

import { Container, useStyles } from './CreateFromButtons.styled';

const COPIES = strings.candidates.creation.sourceButtons;

const BUTTONS_CONFIG = [
  {
    Icon: PersonAddIcon,
    source: SOURCES.FROM_SCRATCH,
    title: COPIES.scratch.title,
    description: COPIES.scratch.description
  },
  {
    Icon: PeopleAltIcon,
    source: SOURCES.FROM_DIRECTORY,
    title: COPIES.directory.title,
    description: COPIES.directory.description
  },
  {
    Icon: InsertDriveFileIcon,
    source: SOURCES.FROM_RESUME,
    title: COPIES.resume.title,
    description: COPIES.resume.description,
    href: EntityRoutes.CandidateCreateFromResume
  },
  {
    Icon: FindInPageIcon,
    source: SOURCES.FROM_TALENT_POOL,
    title: COPIES.talentPool.title,
    description: COPIES.talentPool.description,
    href: TALENT_POOL_URL,
    isExternal: true
  }
];
const getComponent = (isExternal, href) => {
  if (isExternal) return 'a';
  if (href) return Link;
  return 'div';
};

export const CreateFromButtons = ({ onClickFrom }) => {
  const classes = useStyles();

  const handleClick = source => {
    if (source === SOURCES.FROM_SCRATCH || source === SOURCES.FROM_DIRECTORY) {
      onClickFrom(source);
    }
  };

  return (
    <Container>
      <Grid alignItems="stretch" container spacing={2}>
        {BUTTONS_CONFIG.map(({ Icon, title, description, source, href, isExternal }) => (
          <Grid key={source} className={classes.gridItem} item xs={12} sm={6} md={3}>
            <ButtonBase
              aria-label={description}
              className={classes.button}
              component={getComponent(isExternal, href)}
              href={isExternal ? href : undefined}
              onClick={() => handleClick(source)}
              rel={isExternal ? 'noopener noreferrer' : undefined}
              target={isExternal ? '_blank' : undefined}
              to={!isExternal ? href : undefined}
            >
              <Icon className={classes.icon} />

              <div>
                <Typography variant="h6">{title}</Typography>
                <Typography className={classes.description} color="textSecondary" variant="body2">
                  {description}
                </Typography>
              </div>
            </ButtonBase>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};
